/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2017/11/8 10:56
 * @desc
 */
import { render } from 'react-dom'
import Home from './src/Home'
import './home.less'

render(<Home lang='en' />, document.getElementById('root'))
